import { useStore } from '@stores';
import { useEffect } from 'react';

export const useUser = (id: number) => {
  const { userStore } = useStore();
  const { user, loading } = userStore;

  useEffect(() => {
    userStore.get({ id });

    return () => {
      userStore.clearUser();
    };
  }, [userStore, id]);

  return { user, loading };
};
